import { z } from "zod";

const BrowseDomainsQueryParentSchema = z.object({
  id: z.string().array().nullable(),
});

const BrowseDomainsQuerySchema = z.object({
  parent: BrowseDomainsQueryParentSchema,
});

const BrowseDomainsSchema = z.object({
  search: z.string(),
  page: z.number().min(1, { message: "Page is out of bounds" }),
  query: z.any(),
  sort: z.array(z.object({ property: z.string(), asc: z.boolean() })).nullish(),
});

export default BrowseDomainsSchema;
